module.exports = __webpack_public_path__ + "img/award-bg1.f7c5c3b4.png";